import { useState } from 'react';

import RefreshButton from '../../../../atoms/RefreshButton';
import { EventFilters, HistoryEvent, eventingApi } from '../../../../../services/eventingApi';
import { useApiResource } from '../hooks/useApiResource';
import ResourceState from '../shared/ResourceState';
import { Section, buttonClass } from '../shared/ui';
import EventFiltersForm from './EventFiltersForm';
import EventsTable from './EventsTable';
import { HistoryWindow, MAX_REPLAY, initialFilters, windowOf } from './history';
import { useSelection } from './useSelection';

interface EventsTabProps {
  onOpen: (event: HistoryEvent, historyWindow: HistoryWindow) => void;
  onReplay: (events: HistoryEvent[], historyWindow: HistoryWindow) => void;
}

const EventsTab = ({ onOpen, onReplay }: EventsTabProps) => {
  const [filters, setFilters] = useState<EventFilters>(initialFilters);
  const { selected, toggle, clear } = useSelection(MAX_REPLAY);
  const events = useApiResource(() => eventingApi.listEvents(filters), [filters]);
  const historyWindow = windowOf(filters);
  const rows = events.data ?? [];

  const search = (next: EventFilters) => {
    clear();
    setFilters(next);
  };

  return (
    <div className="space-y-4">
      <Section title="Histórico (Athena)" subtitle="Fatos arquivados pelo Firehose (sem snapshot, replay nem legado); a janela vai até 31 dias">
        <EventFiltersForm busy={events.loading} onSearch={search} />
      </Section>

      <Section
        title={`Eventos (${rows.length})`}
        subtitle={`Selecione até ${MAX_REPLAY} para reprocessar num consumidor`}
        actions={
          <>
            <button
              type="button"
              className={buttonClass.secondary}
              disabled={selected.size === 0}
              onClick={() => onReplay(rows.filter((row) => selected.has(row.message.eventId)), historyWindow)}
            >
              Reprocessar {selected.size || ''}
            </button>
            <RefreshButton variant="icon" label="os eventos" busy={events.loading} onClick={events.reload} />
          </>
        }
      >
        <ResourceState resource={events} emptyText="Nenhum evento no histórico para esse filtro." />
        {rows.length > 0 && <EventsTable events={rows} selected={selected} onToggle={toggle} onOpen={(event) => onOpen(event, historyWindow)} />}
      </Section>
    </div>
  );
};

export default EventsTab;
